export const env = {
  VUE_APP_API_URL: process.env.VUE_APP_API_URL || "__VUE_APP_API_URL__",
  VUE_APP_APP_PROTOCOL:
    process.env.VUE_APP_APP_PROTOCOL || "__VUE_APP_APP_PROTOCOL__"
};
